<template>
  <div id="app">
    <!-- ヘッダー部分 -->
    <myheader></myheader>

    <!-- ↓↓↓ブラウザ戻る抑止モーダル↓↓↓ -->
    <div id="back-modal" class="modal-bg" v-show="modalWindow">
        <div class="modal-frame">
            <div class="modal-cnt">
                <img class="close_modal_button" @click="closeBackModal()">
                <h2 class="back_modal_title">注意</h2>
                <p>ブラウザの戻るボタンは押さないでください。</p>

                <div class="center">
                    <button type="button" class="btn-close" @click="closeBackModal()">
                        <span>閉じる</span>
                    </button>
                </div>
            </div>
        </div>
    </div>
    <!-- ↑↑↑ブラウザ戻る抑止モーダル↑↑↑ -->

    <!-- メインコンテンツ -->
    <seinengappiNyuryoku
      v-bind="commonData"
      v-show="commonData.show == 'seinengappiNyuryoku'"
      @updCommon="updateData"
      @quoteRequest="quoteStart"
      @clearYear="clearYear"
    />
    <planSekkei
      v-bind="commonData"
      v-show="commonData.show == 'planSekkei'"
      @updStp="updateStp"
      @showSeinengappiNyuryoku="showSeinengappiNyuryoku"
      @sendShorichu="sendShorichu"
      @sendCampaign="sendCampaign"
    />
    <yokisenuError
      v-bind="commonData"
      v-show="commonData.show == 'yokisenuError'"
    />
  </div>
</template>

<script>
import myheader from "./components/header"
import seinengappiNyuryoku from "./components/seinengappiNyuryoku"
import planSekkei from "./components/planSekkei"
import yokisenuError from "./components/yokisenuError"
import check from "@/script/check.js"
import ageUtil from "@/script/age.js"
import jsonUtil from "@/script/getjson.js"
import urlUtil from "@/script/url.js"

export default {
  data() {
    return {
      commonData: {
        kr: "",
        kjc: "",
        ssc: "",
        smc: "",
        hymd: "",
        year: "",
        month: "---",
        day: "---",
        age: 0,
        age3: 0,
        age10: 0,
        sex: "",
        stp: "",
        sts: "",
        lymd: "",
        baseYear: "",
        baseMonth: "",
        baseDay: "",
        warekiYear: "",
        msgTxt: "Web申込は、ニッセイトータルパートナーからのご案内プランに比べ、取扱プランを限定のうえご案内しております。\n入力していただいた生年月日では、Web申込をご利用いただけませんので、お手数ですが画面下部の電話番号までご相談ください。",
        show: "",
        mankiHokenkin:"",
        ruikeiHokenryo: "",
        henreikingaku: "",
        henreikingakuHenreiritsu: "",
        mankiHokenkinHenreiritsu: "",
        shiboHokenkin3: "",
        shiboHokenkin5: "",
        shiboHokenkin7: "",
        shiboHokenkin10: "",
        shogaiShiboHokenkin3: "",
        shogaiShiboHokenkin5: "",
        shogaiShiboHokenkin7: "",
        shogaiShiboHokenkin10: "",
        shiboHokenkinHenreiritsu3: "",
        shiboHokenkinHenreiritsu5: "",
        shiboHokenkinHenreiritsu7: "",
        shiboHokenkinHenreiritsu10: "",
        msgShow: false,
        requested: false
      },
      isUserNavigation: true,
      modalWindow: false,
      getJsonStatus: false,
    }
  },
  name: "App",
  components: {
    myheader,
    seinengappiNyuryoku,
    planSekkei,
    yokisenuError
  },
  //初期処理
  created: function() {
    //URLパラメータ取得
    const params = new URLSearchParams(window.location.search);

    /*-----経路パラメータ取得-----*/
    //流入経路
    const kr = params.get("kr");
    if (kr) {
      this.commonData.kr = kr;
    }
    //企事コード
    const kjc = params.get("kjc");
    if (kjc) {
      this.commonData.kjc = kjc;
    }
    //介在支社支部コード
    const ssc = params.get("ssc");
    if (ssc) {
      this.commonData.ssc = ssc;
    }
    //介在職員氏名コード
    const smc = params.get("smc");
    if (smc) {
      this.commonData.smc = smc;
    }

    /*-----プラン設計パラメータ判定-----*/
    const paramChk = check.chkPlanSekkeiParam(params);
    const hymd = params.get("hymd");
    const hs = params.get("hs");
    const stp = params.get("stp");
    const sts = params.get("sts");
    if (paramChk == "1") {
      //1:プラン設計パラメータなし
      this.commonData.show = "seinengappiNyuryoku";
      history.pushState(null, "", urlUtil.createURL(1, this.commonData));
    } else if (paramChk == "2") {
      //2:プラン設計パラメータあり入力チェック
      /*-----入力チェック-----*/
      //正規表現定義
      const chk8number = /^\d{8}$/;
      const chk1number1to2 = /^[1-2]$/;
      const chk1number1to5 = /^[1-5]$/;
      //チェック
      if (!chk8number.test(hymd) || !chk1number1to2.test(hs) || !chk1number1to5.test(stp) || !chk1number1to5.test(sts)) {
        //正規表現チェックエラー
        this.commonData.show = "yokisenuError";
      } else if (!check.chkDate(hymd)) {
        //日付妥当性チェックエラー
        this.commonData.show = "yokisenuError";
      } else {
        //パラメータ値取得
        this.commonData.hymd = hymd;
        const baseDate = ageUtil.getKeisankijunbi();
        const minYear = baseDate.getFullYear() - 50;
        const nowDate = ageUtil.getJstNowDate();
        const maxYear = nowDate.getFullYear() - 18;
        const bdYear = parseInt(hymd.slice(0, 4).replace(/^0+/, ""));
        if(bdYear < minYear || bdYear > maxYear){
          this.commonData.year = "";
        } else {
          this.commonData.year = String(bdYear);
        }
        this.commonData.month = hymd.slice(4, 6).replace(/^0+/, "");
        this.commonData.day = hymd.slice(6, 8).replace(/^0+/, "");
        this.commonData.sex = hs;
        this.commonData.stp = stp;
        this.commonData.sts = sts;
        /*-----見積り開始-----*/
        this.quoteStart()
      }
    } else {
      //e:プラン設計パラメータ不足
      /*-----予期せぬエラー画面 -----*/
      this.commonData.show = "yokisenuError";
    }
  },
  mounted: function() {

    /*-----ブラウザバック抑止処理-----*/
    window.addEventListener("popstate", () => {
      window.history.pushState(null, "", window.location.href);
      this.modalWindow = true;

      if (this.commonData.show == "seinengappiNyuryoku") {
        history.pushState(null, "", urlUtil.createURL(1, this.commonData));
      } else if (this.commonData.show == "planSekkei") {
        history.pushState({}, "", urlUtil.createURL(2, this.commonData));
      }
    })

    window.history.pushState(null, "", window.location.href);

    //ブラウザバックモーダルを範囲外押下で閉じる
    var clickModal = document.getElementById("back-modal");
    clickModal.addEventListener("click", (event) => {
      if (event.target.closest("modal-frame") === null) {
        this.modalWindow = false;
      }
    })
  },
  methods: {
    updateData(updYear, updMonth, updDay, updSex, updStp) {
      this.commonData.year = updYear
      this.commonData.month = updMonth
      this.commonData.day = updDay
      this.commonData.sex = updSex
      this.commonData.stp = updStp
      this.commonData.sts = updStp
      this.commonData.hymd = updYear + updMonth.padStart(2, "0") + updDay.padStart(2, "0")
    },
    updateStp(updStp) {
      this.commonData.stp = updStp;
      this.quoteStart();
    },
    showSeinengappiNyuryoku() {
      this.commonData.show = "seinengappiNyuryoku";
      history.pushState({}, "", urlUtil.createURL(1, this.commonData));
    },
    showPlanSekkei() {
      this.commonData.show = "planSekkei";
      history.pushState({}, "", urlUtil.createURL(2, this.commonData));
    },
    sendShorichu() {
      if (!this.requested) {
        this.requested = true
        window.location.href = urlUtil.createURL(3, this.commonData);
      }
    },
    //キャンペーン対応で使用するロジック
    sendCampaign() {
      if (!this.requested) {
        this.requested = true;
        window.location.href = urlUtil.createURL(4, this.commonData);
      }
    },
    async quoteStart() {
        /*-----契約年齢チェック-----*/
        //計算日
        const jstNowDate = ageUtil.getJstNowDate();
        const thisYear = String(jstNowDate.getFullYear());
        const thisMonth = String(jstNowDate.getMonth() + 1);
        const thisDay = String(jstNowDate.getDate());
        this.commonData.lymd = thisYear + thisMonth.padStart(2, "0") + thisDay.padStart(2, "0");

        //計算基準日保存
        const keisanKijunbi = ageUtil.getKeisankijunbi();
        const baseYear = String(keisanKijunbi.getFullYear());
        const baseMonth = String(keisanKijunbi.getMonth() + 1);
        const baseDay = String(keisanKijunbi.getDate());
        this.commonData.baseYear = baseYear;
        this.commonData.baseMonth = baseMonth;
        this.commonData.baseDay = baseDay;

        //年齢算出
        const realAge = ageUtil.getAge(this.commonData.year, this.commonData.month, this.commonData.day, jstNowDate);
        const keiyakujiAge = ageUtil.getAge(this.commonData.year, this.commonData.month, this.commonData.day, keisanKijunbi);

        if (check.chkAge(realAge, keiyakujiAge)) {
          //年齢範囲確認：範囲内
          this.commonData.msgShow = false;

          this.commonData.age = keiyakujiAge;
          this.commonData.age3 = keiyakujiAge + 3;
          this.commonData.age10 = keiyakujiAge + 10;

          /*-----JSON読込-----*/
          await jsonUtil.getJsonFile(this.commonData.stp, this.setKyotsuKakakuJoho, this.setPlanSekkeiKekka, this.setJsonStatus);
          if (this.getJsonStatus) {
            //JSON読込：成功
            this.commonData.warekiYear = this.getWarekiYear(this.commonData.year, this.commonData.month, this.commonData.day);
            this.commonData.show = "planSekkei";
            history.pushState({}, "", urlUtil.createURL(2, this.commonData));
            window.scrollTo({
                top: 305,
                behavior: "auto"
            })
          } else {
            //JSON読込：失敗
            this.commonData.show = "yokisenuError";
          }

        } else {
          //年齢範囲確認：範囲外
          window.scrollTo({
            top: 0,
            behavior: "auto"
          });
          this.commonData.msgShow = true;
          this.commonData.show = "seinengappiNyuryoku";
        }
    },
    getWarekiYear(strYear, strMonth, strDay) {
      if (strYear == "") {
        return "---"
      }

      const year = parseInt(strYear);
      const month = parseInt(strMonth);
      const day = parseInt(strDay);
      const date = new Date(year, month - 1, day);

      if (date >= new Date(2019, 4, 1)) {
        const warekiYear = String(year - 2018);
        return "令和" + warekiYear
      } else if (date >= new Date(1989, 0, 8)) {
        const warekiYear = String(year - 1988);
        return "平成" + warekiYear
      } else if (date >= new Date(1926, 11, 25)) {
        const warekiYear = String(year - 1925);
        return "昭和" + warekiYear
      } else {
        return "---"
      }
    },
    setKyotsuKakakuJoho: function (response) {
      const sts = String(response[0].mankiHokenkinHyj);
      const mankiHokenkin = String(response[0].mankiHokenkin);

      this.commonData.sts = sts;
      this.commonData.mankiHokenkin = this.commaEdit(mankiHokenkin).padStart(9, " ");
    },
    setPlanSekkeiKekka: function (response) {
      const ruikeiHokenryo = String(response[0].ruikeiHokenryo);
      const henreikingaku = String(response[0].henreikingaku);
      const henreikingakuHenreiritsu = response[0].henreikingakuHenreiritsu;
      const mankiHokenkinHenreiritsu = response[0].mankiHokenkinHenreiritsu;
      const shiboHokenkin3 = String(response[0].suii[0].shiboHokenkin);
      const shiboHokenkin5 = String(response[0].suii[1].shiboHokenkin);
      const shiboHokenkin7 = String(response[0].suii[2].shiboHokenkin);
      const shiboHokenkin10 = String(response[0].suii[3].shiboHokenkin);
      const shogaiShiboHokenkin3 = String(response[0].suii[0].shogaiShiboHokenkin);
      const shogaiShiboHokenkin5 = String(response[0].suii[1].shogaiShiboHokenkin);
      const shogaiShiboHokenkin7 = String(response[0].suii[2].shogaiShiboHokenkin);
      const shogaiShiboHokenkin10 = String(response[0].suii[3].shogaiShiboHokenkin);
      const shiboHokenkinHenreiritsu3 = response[0].suii[0].shiboHokenkinHenreiritsu;
      const shiboHokenkinHenreiritsu5 = response[0].suii[1].shiboHokenkinHenreiritsu;
      const shiboHokenkinHenreiritsu7 = response[0].suii[2].shiboHokenkinHenreiritsu;
      const shiboHokenkinHenreiritsu10 = response[0].suii[3].shiboHokenkinHenreiritsu;

      this.commonData.ruikeiHokenryo = this.commaEdit(ruikeiHokenryo).padStart(9, " ");
      this.commonData.henreikingaku = this.commaEdit(henreikingaku);
      this.commonData.henreikingakuHenreiritsu = henreikingakuHenreiritsu.toFixed(1);
      this.commonData.mankiHokenkinHenreiritsu = mankiHokenkinHenreiritsu.toFixed(1);
      this.commonData.shiboHokenkin3 = this.commaEdit(shiboHokenkin3);
      this.commonData.shiboHokenkin5 = this.commaEdit(shiboHokenkin5);
      this.commonData.shiboHokenkin7 = this.commaEdit(shiboHokenkin7);
      this.commonData.shiboHokenkin10 = this.commaEdit(shiboHokenkin10);
      this.commonData.shogaiShiboHokenkin3 = this.commaEdit(shogaiShiboHokenkin3);
      this.commonData.shogaiShiboHokenkin5 = this.commaEdit(shogaiShiboHokenkin5);
      this.commonData.shogaiShiboHokenkin7 = this.commaEdit(shogaiShiboHokenkin7);
      this.commonData.shogaiShiboHokenkin10 = this.commaEdit(shogaiShiboHokenkin10);
      this.commonData.shiboHokenkinHenreiritsu3 = shiboHokenkinHenreiritsu3.toFixed(1);
      this.commonData.shiboHokenkinHenreiritsu5 = shiboHokenkinHenreiritsu5.toFixed(1);
      this.commonData.shiboHokenkinHenreiritsu7 = shiboHokenkinHenreiritsu7.toFixed(1);
      this.commonData.shiboHokenkinHenreiritsu10 = shiboHokenkinHenreiritsu10.toFixed(1);
    },
    setJsonStatus: function (status) {
      this.getJsonStatus = status;
    },
    commaEdit(numStr) {
      return numStr.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    closeBackModal() {
        this.modalWindow = false;
    },
    clearYear() {
      this.commonData.year = "";
    }
  },
  beforeDestroy() {
  }
}
</script>

<style>
#app {
  font-family: "Hiragino Kaku Gothic Pro", Meiryo, Osaka, "MS PGothic", sans-serif !important;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #333;
}

html {
  font-size: 62.5%;
}

/* 以下、共通CSS */
*, *::before, *::after {
  box-sizing: border-box;
}

select {
  color: black;
  text-align: center;
  text-align-last: center;
  line-height: normal;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
}

::-ms-expand {
  display: none;
}

input[type="text"]{
  -webkit-appearance: none;
  appearance: none;
}

button {
  font-family: "Hiragino Kaku Gothic Pro", Meiryo, Osaka, "MS PGothic", sans-serif !important;
}

ul {
  padding-inline-start: 0;
}

/* メインエリア */
.mainArea {
  background-color: #FAF7F0;
  padding-top: 5px;
}

/* container */
.container_pc {
  padding: initial;
  padding-left: 15px;
  padding-right: 15px;
  overflow: hidden;
  max-width: 920px;
  margin: 0 auto;
}

.container_phone {
  padding: initial;
  width: 100%;
  margin: 0 auto;
  overflow: hidden;
}

.modal_font {
  font-size: 14px;
  margin: 40px;
}

.logo {
  width: 136px;
}

.logo-header-smaphonenkin {
  height: 78px;
  background: url(./image/chokotumi_logoA.png) no-repeat;
  background-size: contain;
  width: 140px;
}

/* ヘッダー画像右寄せ*/
.logo-header-right {
  margin: 0 0 -20px auto;
}

/* 『次へ』ボタン */
.btn-next-new {
  max-width: 315px;
  width: 100%;
  height: 64px;
  margin-top: 10px;
  margin-bottom: 25px;
  border: 1px solid #f00000;
  border-radius: 30px;
  background: #f00000;
  box-shadow: 0 5px 10px -5px #cccccc;
  margin-top: 40px;
}

.btn-next-new span {
  font-size: 18px;
  font-weight: bold;
  display: block;
  padding: 10px 0;
  text-align: center;
  color: #fff;
}

.btn-next-new:disabled {
  max-width: 315px;
  width: 100%;
  height: 64px;
  margin-top: 10px;
  margin-bottom: 25px;
  border: 1px solid #cccccc;
  border-radius: 30px;
  background: #bfbfbf;
  box-shadow: 0 5px 10px -5px #cccccc;
  margin-top: 40px;
}

/* h2タグ_お見積もり */
.hdg2-mitsumori {
  border-bottom: 4px solid #f00;
	padding-left: 0px;
	padding-bottom: 7px;
	width: 100%;
	height: 48px;
	font-family: "Hiragino Sans" !important;
	font-style: normal;
	font-weight: 700;
	font-size: 3.2rem;
	line-height: 3.2rem;
	display: flex;
	align-items: flex-end;
	color: #333333;
	flex: none;
	order: 1;
	flex-grow: 0;
	margin: 32px 0 8px 0;
  float: left;
}

@media screen and (max-width: 480px) {
  .hdg2-mitsumori {
    font-size: 2.4rem;
    line-height: 2.4rem;
  }
}

.hdg2-mitsumori5 {
  border-bottom: 4px solid #f00;
	width: 90%;
	height: 48px;
	font-family: "Hiragino Sans" !important;
	font-style: normal;
	font-weight: 700;
	font-size: 1.8rem;
	line-height: 36px;
	display: flex;
	align-items: center;
	color: #333333;
	flex: none;
	order: 1;
  flex-grow: 0;
  margin: 40px 40px 10px 40px;
}

/* ▼大枠 */
.nenFixWord {
  position: relative;
}

/* ▼赤 */
.triangle {
  content: "";
  position: absolute;
  right: 15px;
  top: -1px;
  width: 0px;
  height: 0px;
  border-top: 7px solid #ED1C24;
  border-top-width: 12px;
  border-right: 7px solid transparent;
  border-right-width: 7px;
  border-left: 7px solid transparent;
  border-left-width: 8px;
  z-index: 1;
  pointer-events: none;
}

/* ヘルプアイコン */
.helpicon_shosai {
  width: 16px;
  height: 16px;
  vertical-align: sub;
  margin: 3px 3px;
}

/* 『戻る』ボタン */
.btn-back-new {
  max-width: 150px;
  width: 100%;
  height: 50px;
  margin-top: 10px;
  margin-bottom: 25px;
  border-bottom: 1px solid #cccccc;
  border: 1px solid #f5f5f5;
  border-radius: 25px;
  background: #ffffff;
  box-shadow: 0 4px 8px rgba(0,0,0,0.05);
}

.btn-back-new span {
  font-size: 1.4rem;
  font-weight: bold;
  position: relative;
  display: block;
  padding: 12px 0px 13px 0px;
  text-align: center;
  color: #666;
}

/* 『閉じる』ボタン */
.btn-close {
  max-width: 180px;
  width: 200px;
  height: 48px;
  margin-top: 10px;
  margin-bottom: 30px;
  border: 1px solid #CCC;
  border-radius: 25px;
  background: #ffffff;
  box-shadow: 0 4px 8px rgba(0,0,0,0.05);
}

.btn-close span {
  font-size: 1.6rem;
  font-weight: bold;
  display: block;
  padding: 10px 0;
  text-align: center;
  color: #666;
}

/* 『×』ボタン */
.close_modal_button {
  display: inline-block;
  height: 20px;
  padding: 0 10px;
  background: url(./image/Close.png) no-repeat;
  background-size: 20px;
  position: absolute;
  top: 22px;
  right: 10px;
  cursor: pointer;
}

/* 『×』ボタン（月払保険料モーダル） */
.close_modal_button2 {
  top: 50px;
  right: 45px;
}

@media screen and (max-width: 480px) {
  .modal_font {
    margin: 10px;
  }

  .hdg2-mitsumori5 {
    width: 93%;
    margin: 40px 0px 10px 10px;
  }

  .close_modal_button2 {
    right: 25px;
  }
}

/* 小技系 */
.center {
  text-align: center;
}

.right {
  text-align: right;
}

.left {
  text-align: left;
}

.indent {
  text-indent: -1em;
  padding-left: 1em;
}

.indent2 {
  text-indent: 0em;
  padding-left: 1em;
}

.indent3 {
  text-indent: -2.3em;
  padding-left: 2em;
}

.margin_right {
  margin-right: 15px;
}

/* 全体モーダルの調整 */
.modal .modal-content {
  border-radius: 1.5rem;
}

.modal .modal-dialog {
  max-width: 800px;
}

/* フッター */
@media screen and (min-width: 481px) {
  a[href^="tel:"]{
    pointer-events: none;
  }
}

.footer_align {
  background-color: #ffffff;
  padding-top: 20px;
  padding-bottom: 20px;
}

.div_center {
  text-align: center;
  margin-top: 15px;
}

.span_font1 {
  font-size: 1.7rem;
  font-weight: bold;
  line-height: 23px;
}

.a_phone {
  text-decoration: none;
  font-size: 1.7rem;
  color: #333;
  font-weight: bold;
}

.span_font2 {
  font-size: 1.3rem;
}

.div_border {
  border-bottom: 5px solid #ED1C24;
}

.nav-top2 {
  margin-top: 10px;
  height: 48px;
  text-align: center;
  border-top: 1px solid #2c2b2b;
  background: -webkit-linear-gradient(90deg, #383838 0%, #595757 100%);
  background: linear-gradient(0deg, #383838 0%, #595757 100%);
  cursor: pointer;
}

.nav-top2 .nav-top-txt {
  font-weight: bold;
  display: block;
  padding: 13px 0 15px;
  text-decoration: none;
  color: #fff;
}

.nav-top2 .nav-top-txt .nav-top-icon {
  padding: 4px 0 4px 28px;
  background: url(./image/CmnArrow.png) no-repeat left center;
  background-size: 20px;
  font-size: 1.4rem;
}

.span_bottom {
  font-size: 1.2rem;
  color: #666;
}

/* ブラウザ戻る抑止モーダル */
.back_modal_title {
  border-bottom: 8px solid #ed1c24;
  padding-bottom: 5px;
  width: 100%;
  font-weight: bold;
  font-size: 20px;
  align-items: flex-end;
  color: #333333;
  margin-bottom: 15px;
  text-align: center;
  padding-top: 30px;
}

.modal-bg {
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .6);
  top: 0;
  left: 0;
  z-index: 3;
}

.modal-bg.active {
  display: block;
}

.modal-frame {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.modal-cnt {
  width: 360px;
  height: 280px;
  background-color: #fff;
  position: relative;
  box-sizing: border-box;
  border-radius: 0px;
}

.modal-cnt>p {
  margin-left: 15px;
  margin-bottom: 100px;
  font-size: 16px;
}
</style>
